module.exports = __webpack_public_path__ + "img/apollon_logo.eb68b3c0.png";